import AutoDetectDeviceModal from './AutoDetectDeviceModal';

export default AutoDetectDeviceModal;
